import type {
  CompleteRegistrationUserData,
  IdentityDocumentContentType,
} from '@/modules/auth/use-cases'

export type LicenseEntry = {
  licenseNumber: string
  expiry: string
  exempt: boolean
  documentUrl?: string
}

export const EMPTY_LICENSE_ENTRY: LicenseEntry = {
  licenseNumber: '',
  expiry: '',
  exempt: false,
}

export type DriversLicenseEntry = {
  issuingState: string
  documentNumber: string
  expiry: string
  fileName: string
  fileBase64: string
  contentType: IdentityDocumentContentType
}

export const EMPTY_DRIVERS_LICENSE_ENTRY: DriversLicenseEntry = {
  issuingState: '',
  documentNumber: '',
  expiry: '',
  fileName: '',
  fileBase64: '',
  contentType: 'image/jpeg',
}

export type JoinFormValues = Partial<CompleteRegistrationUserData> & {
  licenseEntries?: Record<string, LicenseEntry>
  driversLicense?: DriversLicenseEntry
}
